var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAvaxLogo = function SvgAvaxLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0767 10.5736C14.6372 9.79252 13.9342 9.79252 13.4947 10.5736L10.7201 15.4776C10.2807 16.2459 10.6448 16.8861 11.5111 16.8861H17.0101C17.8889 16.8861 18.253 16.2459 17.8136 15.4776L15.0767 10.5736Z",
    fill: "#E3453D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8627 4.79904L10.4188 2.19977L9.80363 1.0858C9.36424 0.304735 8.66115 0.304735 8.22171 1.0858L0.186618 15.4651C-0.252802 16.2461 0.111289 16.8735 0.990127 16.8735H3.22489H4.75659H5.02024C5.74844 16.8735 6.65236 16.3485 7.01646 15.6955L11.8627 7.14223C12.2142 6.51483 12.2142 5.45206 11.8627 4.79904Z",
    fill: "#E3453D"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvaxLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avax_logo.5f4cb6ec.svg";
export { ForwardRef as ReactComponent };